import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    courses: [],
}

const recentlyViewedSlice = createSlice({
    name: 'recentlyViewed',
    initialState,
    reducers: {
        addCourse: (state, action) => {
            const itemAlreadyExists = state.courses.some(
                ({ coursecode }) => coursecode === action.payload.coursecode
            )
            if (!itemAlreadyExists) {
                //Make sure there are only three courses in array at any point in time
                state.courses = [...state.courses, action.payload].slice(-3)
            }
        },
    },
})

const { addCourse } = recentlyViewedSlice.actions

export const recentlyViewedActions = {
    addCourse,
}

export const recentlyViewedSelectors = {
    courses: state => state.recentlyViewed.courses,
}

export const recentlyViewedReducer = recentlyViewedSlice.reducer
